export default __webpack_public_path__ + "static/media/may_2025_1.f748c954.jpeg";